export const BASE_API_URL = window.location.hostname === 'localhost' ? 'http://localhost:8080/api' : './api';